import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { injectFromAppUpload } from "../../inject";
import type { FileUpload } from "../../FileUpload";
import { humanizeFileSize } from "../../../util/functions/humanizeFileSize";
import { ParagraphRichToolTipComponent, RichToolTipComponent } from "../../../shared-components/rich-tooltip/RichToolTipComponent";
import { ProgressBarComponent } from "../../../shared-components/progress-bar/ProgressBarComponent";
import type { IUploadStore } from "../../UploadStore";

interface IFileUploadComponentProps {
    resourcesStore?: IResourcesStore;
    uploadStore?: IUploadStore;
    file: FileUpload;
}

@injectFromAppUpload<IFileUploadComponentProps>(stores => ({
    uploadStore: stores.uploadStore,
    resourcesStore: stores.resourcesStore,
}))
@observer
export class FileUploadComponent extends React.Component<IFileUploadComponentProps> {
    remove = (event): void => {
        const { file, uploadStore } = this.props;
        uploadStore!.removeFileUpload(file);
    };

    render() {
        const { resourcesStore, file } = this.props;
        const { fileError, checking, fileIsSupported, fileIsADicomDirFile, removable, uploadable, fileNameLengthIsOk, progress, name, size, status } = file;
        const { resources } = resourcesStore!;

        const sliceName: boolean = name.length > 40;
        const displayName = sliceName ? name.slice(0, 40) + "..." : name;

        let selectedFileClasses: string = "";
        if (checking) {
            selectedFileClasses = "checking";
        } else {
            selectedFileClasses = uploadable ? "uploadable" : "not-uploadable";
        }

        return (
            <div className={"selected-file " + selectedFileClasses}>
                {!checking && !uploadable && (
                    <>
                        <div className={"info"}>
                            {sliceName ? (
                                <ParagraphRichToolTipComponent toolTipPosition={"top-left"} toolTipContent={name}>
                                    {displayName} <span>({humanizeFileSize(size)})</span>
                                </ParagraphRichToolTipComponent>
                            ) : (
                                <p>
                                    {displayName} <span>({humanizeFileSize(size)})</span>
                                </p>
                            )}
                        </div>
                        <p className={"reason"}>
                            {fileError && (
                                <>
                                    {resources.SomethingWentWrong} <br />
                                </>
                            )}
                            {!fileIsSupported && !fileError && (
                                <>
                                    {resources.ThisIsNotASupportedFile} <br />
                                </>
                            )}
                            {!fileNameLengthIsOk && !fileError && (
                                <>
                                    {resources.FilenameLengthTooLarge} <br />
                                </>
                            )}
                            {fileIsADicomDirFile && !fileError && (
                                <>
                                    {resources.DICOMDIRFilesAreUnnecessary} <br />
                                </>
                            )}
                        </p>
                    </>
                )}
                {!checking && uploadable && (
                    <ProgressBarComponent progress={progress} status={status} detailed={true}>
                        {displayName} <span>({humanizeFileSize(size)})</span>
                    </ProgressBarComponent>
                )}
                {removable && (
                    <RichToolTipComponent toolTipResource={"RemoveFile"} className={"remove-file"} onClick={this.remove}>
                        &nbsp;
                    </RichToolTipComponent>
                )}
            </div>
        );
    }
}
